<template>
  <div class="VR">
    <div class="m">
      <template v-if="layerpageinfo.total > 0">
        <div class="school_index_page_b">
          <vr :list="list" type="link"/>
        </div>
        <!-- 分页 -->
        <div class="page_box">
          <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
        </div>
      </template>
      <!-- 为空 -->
      <div class="no_list" v-else></div>
    </div>
  </div>
</template>

<script>
  import vr from "@/components/list_item/vr/vr_list.vue";
  import myPage from "@/components/myPage/myPage";
  export default {
    components:{
      vr,
      myPage
    },
    data(){
      return{
        params:{},
        layerpageinfo:{
          pageNo: 0,
          pageSize: 12,
          total: 0
        },
        searchObj:{
          name: ''
        },
        list: []
      }
    },
    created() {
      this.getList();
    },
    methods:{
      // 页数切换
      changePage(pageNo) {
        this.layerpageinfo.pageNo = pageNo;
        this.getList();
      },
      search(){
        this.layerpageinfo.pageNo = 0;
        this.getList();
      },
      //查询展览列表
      getList(){
        let params = {
          ...this.layerpageinfo,
          ...this.searchObj
        }
        this.api.getFrontVrs(params).then(res=>{
          if(res.error['err_code'] !== 0) return;
          this.list = res.obj.list;
          this.layerpageinfo.total = res.obj.totalSize;
        })
      },
    }
  }
</script>

<style lang="scss">
.VR{
    padding: 20px 0;
}
</style>
